import { call, put } from 'redux-saga/effects';
import api from '../../../../../../services/api';
import { setState } from '../actions';
import { Submissions } from '../../types/submissions';

export function* loadDraftsWorker() {
  try {
    yield put(setState({ isLoadingDraftList: true }));
    const { data } = yield call(api.get, '/v1/custom-forms/drafts');
    yield put(setState({ draftList: (data?.Data ?? []) as Submissions[] }));
  } catch (err) {
    console.log('Failed to load drafts', err);
  } finally {
    yield put(setState({ isLoadingDraftList: false }));
  }
}
